import React from 'react';
import PropTypes from 'prop-types';
import { Flex } from 'rebass';

import Text from '../Text';
import { FONT_SIZE } from '../../Theme';
import { getFormattedNumber, FORMAT_MODE } from './utils';

const NumberBase = ({ value, color, ...restProps }) => (
  <Text color={color} {...restProps}>
    {value}
  </Text>
);

const NumberWithLabel = ({ value, label, color, numSize, ...restProps }) => {
  const fontSize = numSize === 'large' ? FONT_SIZE.semilarge : 'inherit';
  return (
    <Flex py={2} justifyContent={'space-between'} {...restProps}>
      <Text fontWeight={'bold'} color={color}>
        {label}
      </Text>
      <NumberBase value={value} color={color} fontSize={fontSize} ml={2} />
    </Flex>
  );
};

const Number = ({ value, variant, numSize, label, color, ...restProps }) => {
  const num = getFormattedNumber(value, variant);
  return label ? (
    <NumberWithLabel value={num} label={label} color={color} numSize={numSize} {...restProps} />
  ) : (
    <NumberBase value={num} color={color} {...restProps} />
  );
};

Number.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  variant: PropTypes.oneOf(Object.values(FORMAT_MODE)),
};

export default Number;
